import Api from './Api';
const endPoint = 'Settings';

const getAdmins = admins => Api.post(`${endPoint}/filter`, admins);
const saveAdmin = admin => Api.post(`${endPoint}/save`, admin);
const removeAdmin = admin => Api.post(`${endPoint}/remove`, admin);

export {
    getAdmins,
    saveAdmin,
    removeAdmin,
}